<!--Botón + Spinner-->
<button type="button" [disabled]="disabled || loading" mat-flat-button [color]="color" #saveButton
  (click)="submit(); $event.preventDefault()">
  <div class="loading-button-content">
    <mat-spinner class="loading-btn" *ngIf="loading" [diameter]=24 [strokeWidth]="3" color="warn"></mat-spinner>
    <span *ngIf="!loading">{{msg}}</span>
    <span *ngIf="loading">{{loadingMsg}}</span>
  </div>
</button>
